const quotes = [
  {
    text: "Cada dia é uma nova oportunidade para crescer.",
    author: "Anônimo"
  },
  {
    text: "Pequenos progressos diários levam a grandes resultados.",
    author: "Anônimo"
  },
  {
    text: "A consistência é a chave do sucesso.",
    author: "Anônimo"
  },
  {
    text: "Seus hábitos moldam seu futuro.",
    author: "Anônimo"
  },
  {
    text: "O que você faz todos os dias importa mais do que o que você faz de vez em quando.",
    author: "Gretchen Rubin"
  },
  {
    text: "A excelência não é um ato, mas um hábito.",
    author: "Aristóteles"
  },
  {
    text: "Todo dia é uma chance de ser melhor que ontem.",
    author: "Anônimo"
  },
  {
    text: "Grandes jornadas começam com pequenos passos.",
    author: "Confúcio"
  },
  {
    text: "A disciplina é a ponte entre metas e realizações.",
    author: "Jim Rohn"
  },
  {
    text: "Bons hábitos são tão difíceis de formar quanto os ruins são de quebrar.",
    author: "Benjamin Franklin"
  },
  {
    text: "A única maneira de fazer um ótimo trabalho é amar o que você faz.",
    author: "Steve Jobs"
  },
  {
    text: "A vida é 10% o que acontece com você e 90% como você reage a isso.",
    author: "Charles R. Swindoll"
  },
  {
    text: "O sucesso é ir de fracasso em fracasso sem perder o entusiasmo.",
    author: "Winston Churchill"
  },
  {
    text: "A única limitação para o nosso sucesso de amanhã são as nossas dúvidas de hoje.",
    author: "Franklin D. Roosevelt"
  },
  {
    text: "Acredite que você pode e você já está no meio do caminho.",
    author: "Theodore Roosevelt"
  },
  {
    text: "A melhor maneira de prever o futuro é criá-lo.",
    author: "Peter Drucker"
  },
  {
    text: "Não espere. O tempo nunca será justo.",
    author: "Napoleon Hill"
  },
  {
    text: "A persistência é o caminho do êxito.",
    author: "Charles Chaplin"
  },
  {
    text: "A única coisa que interfere com meu aprendizado é a minha educação.",
    author: "Albert Einstein"
  },
  {
    text: "A vida é o que acontece quando você está ocupado fazendo outros planos.",
    author: "John Lennon"
  },
  {
    text: "O que você obtém ao alcançar seus objetivos não é tão importante quanto o que você se torna ao alcançá-los.",
    author: "Zig Ziglar"
  },
  {
    text: "A coragem é a resistência ao medo, o domínio do medo, não a ausência do medo.",
    author: "Mark Twain"
  },
  {
    text: "A motivação é a energia que nos move em direção aos nossos objetivos.",
    author: "Desconhecido"
  },
  {
    text: "A vida é como uma bicicleta. Para manter o equilíbrio, você deve continuar se movendo.",
    author: "Albert Einstein"
  },
  {
    text: "A vida é uma aventura. Embarque nela com coragem e esperança.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma aventura ousada ou nada.",
    author: "Helen Keller"
  },
  {
    text: "A motivação é o que te faz continuar quando você quer desistir.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um desafio. Supere-o com determinação e garra.",
    author: "Desconhecido"
  },
  {
    text: "A vida é feita de escolhas. Quando você dá um passo à frente, inevitavelmente alguma coisa fica para trás.",
    author: "Anônimo"
  },
  {
    text: "A vida é um jogo. Jogue para vencer.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode ser a luz que ilumina o caminho dos outros.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se manter motivado é cercar-se de pessoas positivas.",
    author: "Desconhecido"
  },
  {
    text: "Acredite na sua capacidade de superar qualquer barreira.",
    author: "Desconhecido"
  },
  {
    text: "Acreditar em si mesmo é o primeiro segredo do sucesso.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é o que nos impulsiona a buscar a excelência em tudo o que fazemos.",
    author: "Desconhecido"
  },
  {
    text: "A coragem não é a ausência de medo, mas sim a decisão de que algo é mais importante do que o medo.",
    author: "Ambrose Redmoon"
  },
  {
    text: "A motivação é o que nos leva a perseguir nossas paixões e alcançar nossos objetivos.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode ser a mudança que quer ver no mundo.",
    author: "Mahatma Gandhi"
  },
  {
    text: "O homem não é nada além do que ele faz de si mesmo.",
    author: "Jean-Paul Sartre"
  },
  {
    text: "Acredite que você é capaz de alcançar tudo o que deseja.",
    author: "Desconhecido"
  },
  {
    text: "O sucesso é a soma de pequenos esforços repetidos dia após dia.",
    author: "Robert Collier"
  },
  {
    text: "A melhor maneira de se prever o futuro é criá-lo.",
    author: "Peter Drucker"
  },
  {
    text: "A ação é a chave fundamental para todo sucesso.",
    author: "Pablo Picasso"
  },
  {
    text: "A vida é como andar de bicicleta. Para manter o equilíbrio, você deve se manter em movimento.",
    author: "Albert Einstein"
  },
  {
    text: "A motivação é o que nos leva a buscar nossos sonhos e torná-los realidade.",
    author: "Desconhecido"
  },
  {
    text: "Acredite na sua capacidade de fazer a diferença.",
    author: "Desconhecido"
  },
  {
    text: "Não espere por oportunidades extraordinárias. Seize momentos comuns e faça-os grandes.",
    author: "Orison Swett Marden"
  },
  {
    text: "Acreditar que você pode já é meio caminho andado.",
    author: "Theodore Roosevelt"
  },
  {
    text: "Acredite que você é capaz de alcançar grandes coisas.",
    author: "Desconhecido"
  },
  {
    text: "A diferença entre uma pessoa bem-sucedida e os outros não é a falta de força, nem a falta de conhecimento, mas sim a falta de vontade.",
    author: "Vince Lombardi"
  },
  {
    text: "A única maneira de fazer um trabalho excelente é amar o que você faz.",
    author: "Steve Jobs"
  },
  {
    text: "A vida não é sobre esperar a tempestade passar, é sobre aprender a dançar na chuva.",
    author: "Vivian Greene"
  },
  {
    text: "Você não pode mudar o vento, mas pode ajustar as velas para chegar ao seu destino.",
    author: "Anônimo"
  },
  {
    text: "A vida é uma viagem, e se você se apaixona pela jornada, você estará apaixonado para sempre.",
    author: "Peter Hagerty"
  },
  {
    text: "A vida é 10% o que acontece comigo e 90% de como eu reajo a isso.",
    author: "Charles R. Swindoll"
  },
  {
    text: "A motivação é o combustível que nos impulsiona a perseguir nossos sonhos.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você tem o poder de moldar o seu próprio destino.",
    author: "Desconhecido"
  },
  {
    text: "Coragem é resistência ao medo, domínio do medo, e não ausência do medo.",
    author: "Mark Twain"
  },
  {
    text: "Acredite no seu potencial e nunca desista dos seus sonhos.",
    author: "Desconhecido"
  },
  {
    text: "O sucesso é ir de fracasso em fracasso sem perder o entusiasmo.",
    author: "Winston Churchill"
  },
  {
    text: "A vida é uma aventura. Não tenha medo de explorar novos caminhos.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é visualizar o sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode e você já está no meio do caminho.",
    author: "Theodore Roosevelt"
  },
  {
    text: "O único lugar onde o sucesso vem antes do trabalho é no dicionário.",
    author: "Vidal Sassoon"
  },
  {
    text: "Não é sobre ter todas as pessoas do mundo pra você. É sobre saber que em algum lugar alguém zela por ti.",
    author: "Clarice Lispector"
  },
  {
    text: "A vida é um desafio. Viva-o com paixão e determinação.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é o que nos impulsiona a realizar nossos sonhos.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é definir objetivos claros e alcançáveis.",
    author: "Desconhecido"
  },
  {
    text: "A verdadeira motivação vem de trabalhar em coisas que nos importamos.",
    author: "Simon Sinek"
  },
  {
    text: "A vida é uma questão de escolhas, e cada escolha que você faz, faz você.",
    author: "John C. Maxwell"
  },
  {
    text: "Você nunca sabe que resultados virão da sua ação. Mas se você não fizer nada, não existirão resultados.",
    author: "Mahatma Gandhi"
  },
  {
    text: "A maior descoberta de todos os tempos é que uma pessoa pode mudar o seu futuro apenas mudando a sua atitude.",
    author: "Oprah Winfrey"
  },
  {
    text: "Acredite em si mesmo, e tudo é possível.",
    author: "Desconhecido"
  },
  {
    text: "Não importa quão devagar você vá, desde que você não pare.",
    author: "Confúcio"
  },
  {
    text: "A vida é um presente. Viva-a com gratidão e amor.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é encarar cada desafio como uma oportunidade de crescimento.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma aventura. Explore-a ao máximo.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma oportunidade. Aproveite-a ao máximo.",
    author: "Desconhecido"
  },
  {
    text: "Nunca é tarde demais para ser o que você poderia ter sido.",
    author: "George Eliot"
  },
  {
    text: "A vida é uma viagem que deve ser percorrida, não importa quão ruins sejam as estradas e as acomodações.",
    author: "Oliver Goldsmith"
  },
  {
    text: "Não é a força, mas a persistência, que leva ao sucesso.",
    author: "Anônimo"
  },
  {
    text: "A melhor maneira de se manter motivado é nunca perder de vista seus sonhos.",
    author: "Desconhecido"
  },
  {
    text: "A persistência é o caminho do êxito.",
    author: "Charles Chaplin"
  },
  {
    text: "A vida é uma jornada. Aproveite cada passo.",
    author: "Desconhecido"
  },
  {
    text: "O medo de perder tira a vontade de ganhar.",
    author: "Ayrton Senna"
  },
  {
    text: "A vida é uma jornada. Faça dela uma aventura inesquecível.",
    author: "Desconhecido"
  },
  {
    text: "Para ser bem-sucedido, a primeira coisa a fazer é apaixonar-se pelo seu trabalho.",
    author: "Mary Lauretta"
  },
  {
    text: "Acredite em si mesmo e chegará um dia em que os outros não terão outra escolha senão acreditar com você.",
    author: "Cynthia Kersey"
  },
  {
    text: "Acredite que você é o arquiteto do seu próprio futuro.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em sua capacidade de transformar o impossível em possível.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é reconhecer cada pequeno progresso.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se manter motivado é manter uma atitude de gratidão.",
    author: "Desconhecido"
  },
  {
    text: "Para ter sucesso, seu desejo pelo sucesso deve ser maior que seu medo do fracasso.",
    author: "Bill Cosby"
  },
  {
    text: "Acreditar é essencial, mas ter atitude é o que faz a diferença.",
    author: "Anônimo"
  },
  {
    text: "Acredite em si próprio e em tudo o que você é. Saiba que há algo dentro de você que é maior do que qualquer obstáculo.",
    author: "Christian D. Larson"
  },
  {
    text: "A persistência realiza o impossível.",
    author: "Provérbio Chinês"
  },
  {
    text: "O insucesso é apenas uma oportunidade para recomeçar com mais inteligência.",
    author: "Henry Ford"
  },
  {
    text: "Acredite que vale a pena viver, e a sua crença ajudará a criar esse fato.",
    author: "William James"
  },
  {
    text: "Se você pode sonhar, você pode fazer.",
    author: "Walt Disney"
  },
  {
    text: "A vida é um presente. Aproveite cada segundo.",
    author: "Desconhecido"
  },
  {
    text: "Nunca desista de um sonho apenas por causa do tempo que levará para realizá-lo. O tempo passará de qualquer forma.",
    author: "Earl Nightingale"
  },
  {
    text: "A melhor maneira de se motivar é estabelecer metas inspiradoras.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você é capaz de realizar coisas incríveis.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma série de experiências, cada uma das quais nos torna maiores, mesmo que seja difícil reconhecer isso.",
    author: "Henry Ford"
  },
  {
    text: "Você não precisa ser grande para começar, mas precisa começar para ser grande.",
    author: "Zig Ziglar"
  },
  {
    text: "Acredite em seu potencial ilimitado.",
    author: "Desconhecido"
  },
  {
    text: "A vida encolhe ou se expande proporcionalmente à coragem de alguém.",
    author: "Anaïs Nin"
  },
  {
    text: "A melhor maneira de se motivar é estabelecer metas desafiadoras e alcançá-las.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é ter fé em si mesmo e em suas habilidades.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em si mesmo! Tenha fé em suas habilidades! Sem uma confiança humilde, mas razoável em seus próprios poderes, você não pode ser bem-sucedido ou feliz.",
    author: "Norman Vincent Peale"
  },
  {
    text: "A mente é tudo. O que você pensa, você se torna.",
    author: "Buda"
  },
  {
    text: "O sucesso não é a chave para a felicidade. A felicidade é a chave para o sucesso. Se você ama o que está fazendo, você será bem-sucedido.",
    author: "Albert Schweitzer"
  },
  {
    text: "A motivação é o combustível necessário para alcançar o sucesso.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma oportunidade. Não a deixe escapar.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se manter motivado é estar sempre aprendendo e evoluindo.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um desafio. Aceite-o e vença-o.",
    author: "Desconhecido"
  },
  {
    text: "Acreditar é o primeiro passo para alcançar.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é a arte de fazer as pessoas fazerem o que você quer que elas façam porque elas o querem fazer.",
    author: "Dwight D. Eisenhower"
  },
  {
    text: "A motivação é o ingrediente secreto para alcançar o sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode ser o herói da sua própria história.",
    author: "Desconhecido"
  },
  {
    text: "Acredite na beleza dos seus sonhos e na capacidade de realizá-los.",
    author: "Desconhecido"
  },
  {
    text: "A felicidade não é o objetivo final, é a consequência de uma vida bem vivida.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "A motivação é o que te faz começar. A determinação é o que te mantém no caminho.",
    author: "Desconhecido"
  },
  {
    text: "Não espere por uma crise para descobrir o que é importante em sua vida.",
    author: "Platão"
  },
  {
    text: "A motivação é a chave para o sucesso. Sem ela, nada é possível.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode alcançar o impossível.",
    author: "Desconhecido"
  },
  {
    text: "Acredite no poder dos seus sonhos e trabalhe duro para torná-los realidade.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um desafio. Encare-o com coragem e otimismo.",
    author: "Desconhecido"
  },
  {
    text: "O sucesso não é o final, o fracasso não é fatal: é a coragem para continuar que conta.",
    author: "Winston Churchill"
  },
  {
    text: "A motivação é a chave que abre a porta do sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em si mesmo, mesmo quando ninguém mais acredita.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de motivar os outros é ser um exemplo de motivação a si mesmo.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é o que nos faz buscar nossas metas com paixão e determinação.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é o que te faz começar. O hábito é o que te mantém indo.",
    author: "Jim Ryun"
  },
  {
    text: "A felicidade não é algo que você adia para o futuro; é algo que você projeta para o presente.",
    author: "Jim Rohn"
  },
  {
    text: "O segredo do sucesso é a constância do propósito.",
    author: "Benjamin Disraeli"
  },
  {
    text: "A coragem não é a ausência do medo, mas a capacidade de enfrentá-lo.",
    author: "Nelson Mandela"
  },
  {
    text: "A melhor maneira de se motivar é estar rodeado de pessoas que te inspiram.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você é o único responsável pelo seu sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Eu não falhei. Eu apenas encontrei 10.000 maneiras que não funcionam.",
    author: "Thomas Edison"
  },
  {
    text: "A melhor maneira de se manter motivado é celebrar cada pequena conquista.",
    author: "Desconhecido"
  },
  {
    text: "A dificuldade não está em acreditar em novas ideias, mas em escapar das antigas.",
    author: "John Maynard Keynes"
  },
  {
    text: "O futuro pertence àqueles que acreditam na beleza de seus sonhos.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "A vida não é sobre encontrar a si mesmo. A vida é sobre criar a si mesmo.",
    author: "George Bernard Shaw"
  },
  {
    text: "A diferença entre o possível e o impossível está na determinação de uma pessoa.",
    author: "Tommy Lasorda"
  },
  {
    text: "A única coisa que está entre você e seu objetivo é a história falsa que você continua contando a si mesmo.",
    author: "Jordan Belfort"
  },
  {
    text: "A vida é como uma câmera. Foque no que é importante, capture bons momentos, desenvolva a partir dos negativos e, se as coisas não derem certo, tire outra foto.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um presente. Agradeça por ela todos os dias.",
    author: "Desconhecido"
  },
  {
    text: "A mente é tudo. O que você pensa, você se torna.",
    author: "Buda"
  },
  {
    text: "A vida é um presente. Viva-a com entusiasmo e alegria.",
    author: "Desconhecido"
  },
  {
    text: "A vida é 10% o que acontece conosco e 90% como reagimos a isso.",
    author: "Dennis P. Kimbro"
  },
  {
    text: "A melhor maneira de se manter motivado é definir metas claras e trabalhar para alcançá-las.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em si mesmo! Tenha fé em suas habilidades! Sem uma confiança humilde, mas razoável em seus próprios poderes, você não pode ser bem-sucedido ou feliz.",
    author: "Norman Vincent Peale"
  },
  {
    text: "Você nunca sabe que resultados virão da sua ação. Mas se você não fizer nada, não existirão resultados.",
    author: "Mahatma Gandhi"
  },
  {
    text: "Não espere as oportunidades perfeitas; crie-as.",
    author: "Bruce Lee"
  },
  {
    text: "O insucesso é apenas uma oportunidade para recomeçar com mais inteligência.",
    author: "Henry Ford"
  },
  {
    text: "A persistência é o segredo do sucesso.",
    author: "Calvin Coolidge"
  },
  {
    text: "O sucesso é construído à noite! Durante o dia você faz o que todos fazem.",
    author: "Paulo Vieira"
  },
  {
    text: "Se você quer algo que nunca teve, deve fazer algo que nunca fez.",
    author: "Anônimo"
  },
  {
    text: "Acredite na sua capacidade de fazer a diferença no mundo.",
    author: "Desconhecido"
  },
  {
    text: "A vida não é sobre encontrar a si mesmo. A vida é sobre criar a si mesmo.",
    author: "George Bernard Shaw"
  },
  {
    text: "Para ter sucesso, seu desejo pelo sucesso deve ser maior que seu medo do fracasso.",
    author: "Bill Cosby"
  },
  {
    text: "Acreditar em si mesmo é o primeiro passo para o sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em seu potencial para alcançar grandes realizações.",
    author: "Desconhecido"
  },
  {
    text: "Não espere por uma oportunidade perfeita. Crie-a.",
    author: "George Bernard Shaw"
  },
  {
    text: "Dificuldades preparam pessoas comuns para destinos extraordinários.",
    author: "C.S. Lewis"
  },
  {
    text: "Acredite em sua capacidade de superar obstáculos e alcançar seus sonhos.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma oportunidade. Seja ousado e corajoso para aproveitá-la.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você tem a força necessária para superar qualquer dificuldade.",
    author: "Desconhecido"
  },
  {
    text: "Acredite na sua capacidade de superar qualquer desafio.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que cada dia é uma nova oportunidade para ser melhor do que ontem.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é lembrar-se do porquê você começou.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma tela. Pinte-a com as cores da sua paixão.",
    author: "Desconhecido"
  },
  {
    text: "Acredite no poder dos seus sonhos e na força da sua determinação.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se manter motivado é manter uma atitude positiva.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você tem a capacidade de fazer grandes coisas.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma jornada. Desfrute cada momento como se fosse único.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de motivar os outros é ser um exemplo de motivação a si mesmo.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma jornada. Desfrute de cada passo que der.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um eco. Se você não está gostando do que está recebendo, observe o que está emitindo.",
    author: "Anônimo"
  },
  {
    text: "A melhor maneira de se manter motivado é sempre se lembrar do porquê você começou.",
    author: "Desconhecido"
  },
  {
    text: "A vida é feita de momentos. Faça com que cada um deles conte.",
    author: "Desconhecido"
  },
  {
    text: "A maior glória não é nunca cair, mas sim levantar-se sempre depois de cada queda.",
    author: "Confúcio"
  },
  {
    text: "Acredite que você é o protagonista da sua própria história.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma viagem. Faça dela uma viagem memorável.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um presente. Aprecie cada momento.",
    author: "Desconhecido"
  },
  {
    text: "A ação é a chave fundamental para todo sucesso.",
    author: "Pablo Picasso"
  },
  {
    text: "Acredite em milagres, mas não dependa deles.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um presente. Não a desperdice.",
    author: "Desconhecido"
  },
  {
    text: "A maior glória na vida não é nunca cair, mas sim levantar-se a cada vez que caímos.",
    author: "Nelson Mandela"
  },
  {
    text: "A vida é uma jornada. Curta cada momento.",
    author: "Desconhecido"
  },
  {
    text: "Tudo o que um sonho precisa para ser realizado é alguém que acredite que ele possa ser realizado.",
    author: "Roberto Shinyashiki"
  },
  {
    text: "A vida é uma oportunidade. Agarre-a com todas as suas forças.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se motivar é estar sempre em busca de novas conquistas.",
    author: "Desconhecido"
  },
  {
    text: "A melhor maneira de se manter motivado é ter um propósito claro e significativo.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um desafio. Supere-o com força e determinação.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma jornada. Desfrute de cada passo.",
    author: "Desconhecido"
  },
  {
    text: "A diferença entre o possível e o impossível está na determinação de uma pessoa.",
    author: "Tommy Lasorda"
  },
  {
    text: "O sucesso não é definitivo, o fracasso não é fatal: é a coragem para continuar que conta.",
    author: "Winston Churchill"
  },
  {
    text: "Acredite em sua força interior e na sua capacidade de superar desafios.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é a arte de fazer as pessoas fazerem o que você quer que elas façam porque elas o querem fazer.",
    author: "Dwight D. Eisenhower"
  },
  {
    text: "Acredite em sua capacidade de vencer qualquer desafio.",
    author: "Desconhecido"
  },
  {
    text: "A motivação é o que nos impulsiona a buscar a excelência.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode ser a mudança que deseja ver no mundo.",
    author: "Mahatma Gandhi"
  },
  {
    text: "Acredite que vale a pena viver, e a sua crença ajudará a criar esse fato.",
    author: "William James"
  },
  {
    text: "A vida é como uma câmera. Foque no que é importante, capture bons momentos, desenvolva a partir dos negativos e, se as coisas não derem certo, tire outra foto.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um jogo de equilíbrio. Mantenha-se sempre em movimento para não cair.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que cada dia é uma nova oportunidade para ser melhor do que ontem.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma oportunidade. Aproveite cada chance que tiver.",
    author: "Desconhecido"
  },
  {
    text: "Acredite no poder da sua mente e na força da sua vontade.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um desafio. Aceite-o com entusiasmo e determinação.",
    author: "Desconhecido"
  },
  {
    text: "A vida é um presente. Trate-a com carinho e respeito.",
    author: "Desconhecido"
  },
  {
    text: "Você não pode mudar o vento, mas pode ajustar as velas para chegar ao seu destino.",
    author: "Jimmy Dean"
  },
  {
    text: "Não é a força, mas a persistência, que leva ao sucesso.",
    author: "Anônimo"
  },
  {
    text: "Acreditar que você pode já é meio caminho andado.",
    author: "Theodore Roosevelt"
  },
  {
    text: "O futuro pertence àqueles que acreditam na beleza de seus sonhos.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "Acredite que você tem o poder de escrever a sua própria história.",
    author: "Desconhecido"
  },
  {
    text: "Acredite que você pode voar, e você estará no meio do caminho.",
    author: "Desconhecido"
  },
  {
    text: "A maior descoberta de todos os tempos é que uma pessoa pode mudar o seu futuro apenas mudando a sua atitude.",
    author: "Oprah Winfrey"
  },
  {
    text: "A melhor maneira de se manter motivado é definir metas claras e trabalhar para alcançá-las.",
    author: "Desconhecido"
  },
  {
    text: "Acredite em milagres, mas não dependa deles.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma série de experiências, cada uma das quais nos torna maiores, mesmo que seja difícil reconhecer isso.",
    author: "Henry Ford"
  },
  {
    text: "Se você quer algo que nunca teve, deve fazer algo que nunca fez.",
    author: "Anônimo"
  },
  {
    text: "A vida é um eco. Se você não está gostando do que está recebendo, observe o que está emitindo.",
    author: "Anônimo"
  },
  {
    text: "A vida é um presente. Abra-o com alegria e entusiasmo.",
    author: "Desconhecido"
  },
  {
    text: "Acreditar em si mesmo é o primeiro passo para o sucesso.",
    author: "Desconhecido"
  },
  {
    text: "A vida é uma obra de arte. Crie a sua própria obra-prima.",
    author: "Desconhecido"
  },
  {
    text: "A felicidade não é algo que você adia para o futuro; é algo que você projeta para o presente.",
    author: "Jim Rohn"
  },
  {
    text: "A maior barreira para o sucesso é o medo do fracasso.",
    author: "Sven Goran Eriksson"
  },
  {
    text: "Acredite na sua capacidade de brilhar e fazer a diferença.",
    author: "Desconhecido"
  },
  {
    text: "O otimismo é a fé que leva à realização. Nada pode ser feito sem esperança e confiança.",
    author: "Helen Keller"
  },
  {
    text: "A coragem não é a ausência do medo, mas a capacidade de enfrentá-lo.",
    author: "Nelson Mandela"
  },
  {
    text: "Acredite que cada passo que você dá é um passo em direção ao sucesso.",
    author: "Desconhecido"
  },
  {
    text: "Nosso maior medo não é que sejamos inadequados. Nosso maior medo é que sejamos poderosos além da medida.",
    author: "Marianne Williamson"
  }
];

// Função para obter uma frase baseada na data
export function getQuoteForDay() {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  const quoteIndex = dayOfYear % quotes.length;
  return quotes[quoteIndex];
}

export default quotes; 